import { Modal, Icon, Text, CardActions, CardActionButton } from '@/components'
import { getDateFromTimestamp } from '@/utils/timeUtilities'
import { EnergySystemDemandResponseEvent } from '@/types/energySystemDemandResponseEvent'
import { getEventSettingsText } from './utils'

type Props = {
  event: EnergySystemDemandResponseEvent
  open: boolean
  onClose: () => void
}

export default function EnergySystemDROptInModal(props: Props) {
  const formattedStartTime = getDateFromTimestamp(
    props.event.start_inclusive,
    'h:mm A',
  )
  const formattedEndTime = getDateFromTimestamp(
    props.event.end_exclusive,
    'h:mm A',
  )

  return (
    <Modal
      id="energy-system-dr-opt-out-modal"
      open={props.open}
      onClose={props.onClose}
    >
      <div>
        <div className="flex flex-col items-center w-full justify-center">
          <Icon className="mb-4" name="Check" size={40} />
          <Text variant="subheader" className="max-w-[220px] text-center">
            You rock! Thanks for participating in this event.
          </Text>
          <Text variant="body4" className="mt-4 text-gray-600 px-1 text-center">
            This event runs between {formattedStartTime} to {formattedEndTime}{' '}
            tonight. {getEventSettingsText(props.event)}
          </Text>
        </div>
        <CardActions className="mt-9">
          <CardActionButton
            type="primary"
            onClick={props.onClose}
            id="energy-system-dr-opt-out-modal-done-button"
          >
            Done
          </CardActionButton>
        </CardActions>
      </div>
    </Modal>
  )
}
